import { render, staticRenderFns } from "./nfPage.vue?vue&type=template&id=545d3618&scoped=true&"
import script from "./nfPage.vue?vue&type=script&lang=js&"
export * from "./nfPage.vue?vue&type=script&lang=js&"
import style0 from "./nfPage.vue?vue&type=style&index=0&id=545d3618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d3618",
  null
  
)

export default component.exports